<span [className]="className">
  <p class="multiline-ellipse" [ngStyle]="{'WebkitLineClamp': lineLimit, 'height': ('calc (1em * 1.4 * ' + lineLimit) }">
    <ng-content></ng-content>
  </p>
</span>
